import React, { useState } from "react";
import QRCode from "qrcode.react";
import { banner2, banner3, vritix_logo } from "../../../assets/images/tms-image-list";
import "../../../assets/css/tms-print-ticket/duty-pass.scss";
const DutyPassTicket = ({ from, data, type }) => {
  const [templeDetails] = useState(
    JSON.parse(localStorage.getItem("templeDetails") || "{}")
  );
  return (
    <>
      <img
        src={banner3}
        // src={banner2}
        alt="top-banner"
        style={{ width: "100%", marginBottom: "10px" }}
      />
      <div className="ticket">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {data?.map((item) => {
            return (
              <>
                {(() => {
                  if (item[0] === "image") {
                    return (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                            gap: "10px",
                            marginBottom: 4,
                          }}
                        >
                          <img src={item[1]} className="qr-code" alt="" />
                        </div>
                      </>
                    );
                  }
                })()}
              </>
            );
          })}

          {data?.map((item) => {
            return (
              <>
                {(() => {
                  if (item[0] === "footer") {
                    return (
                      <div className="qr-code-wrapper">
                        <QRCode
                          size={50}
                          value={item[1] ? item[1] : "transactionId=127"}
                        />
                      </div>
                    );
                  }
                })()}
              </>
            );
          })}
        </div>
        {data?.map((item) => {
          return (
            <div key={item[0] + "table"} c>
              {(() => {
                if (item[0] === "header") {
                  return (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <b style={{ margin: "0" }}>{`TI No : ${item[1]}`}</b>

                        <b style={{ margin: "0" }}>{`S No : ${item[3]}`}</b>
                      </div>
                      <div style={{ textAlign: "center", fontSize: "14px" }}>
                        <div>
                          <img
                            alt="logo"
                            style={{
                              width: "20%",
                              justifyContent: "center",
                              margin: "auto",
                              filter: "grayscale(1)",
                            }}
                            src={
                              templeDetails?.logo ? templeDetails?.logo : vritix_logo
                            }
                          />
                        </div>
                        <div
                          style={{
                            justifyContent: "center",
                            margin: "0",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          <p>{templeDetails?.name}</p>
                        </div>
                        {type && (
                          <div
                            style={{
                              justifyContent: "center",
                              margin: "0",
                              fontWeight: "bold",
                              textAlign: "center",
                              textTransform: "capitalize",
                            }}
                          >
                            <p style={{ margin: "0" }}>
                              {type} {from}
                            </p>
                          </div>
                        )}
                        <div
                          style={{
                            display: `${
                              item[5] === "null" || item[5] === "" || !item[5]
                                ? "none"
                                : ""
                            }`,
                            width: "5%",
                            margin: "auto",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "17px",
                              textAlign: "center",
                              fontWeight: "bold",
                              height: "38px",
                              width: "38px",
                              alignItems: "center",
                              display: "grid",
                              border: "2px solid black",
                              borderRadius: "20px",
                              margin: "0 0 3px",
                            }}
                          >
                            {item[5]}
                          </p>
                        </div>
                      </div>
                    </>
                  );
                }
              })()}

              <div
                style={{
                  display: `${
                    item[1] === "null" ||
                    item[0] === "header" ||
                    item[0] === "footer" ||
                    item[0] === "image"
                      ? "none"
                      : "flex"
                  }`,
                }}
              >
                <div
                  style={{
                    width: "40%",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  <p style={item[2]}>{item[0]}</p>
                </div>
                <div
                  style={{
                    width: "60%",
                    overflowWrap: "break-word",
                    textTransform: "capitalize",
                    display: "inline-flex",
                  }}
                >
                  <p className="collen" style={item[2]}>
                    {item[0] !== "" && ":"}
                  </p>
                  <p style={item[2]}>{item[1]}</p>
                </div>
              </div>
              {(() => {})()}
            </div>
          );
        })}
      </div>
      {data?.map((item, index) => {
        return (
          <>
            {(() => {
              if (item[0] === "Department") {
                return (
                  <div key={index} className="department-sign">
                    <img
                      src={
                        item[4] ??
                        "https://spaces.blr1.digitaloceanspaces.com/user-uploads/bd13dd7e-6604-402e-8b54-400080ba7207-Untitled%20design.png"
                      }
                      alt=""
                      height={30}
                      width={80}
                    />
                    <span style={{ fontSize: "9px" }}> Approved By</span>
                  </div>
                );
              }
            })()}
          </>
        );
      })}
      <br />
      {data?.map((item, index) => {
        if (item[0] === "Category") {
          return (
            <>
              <div
                key={index}
                className="category-bottom"
                style={{
                  backgroundColor: `#${item[3]}`,
                  background: `#${item[3]}`,
                }}
              >
                {item[1]}
              </div>{" "}
            </>
          );
        }
      })}

      {data?.map((item, index) => {
        return (
          <div
            key={index}
            className="department-bottom"
            style={{
              backgroundColor: `#${item[3]}`,
              background: `#${item[3]}`,
            }}
          >
            {(() => {
              if (item[0] === "Department") {
                return item[1];
              }
            })()}
          </div>
        );
      })}
    </>
  );
};
export default DutyPassTicket;
